import React from 'react';
import Icon from '../../../components/AppIcon';

// Trust signals for a district evaluator loading the site cold.
// Deliberately no "Privacy Policy" / "Terms of Service" links — the
// previous version had inert buttons that only console.log'd, which
// looks unfinished when someone actually taps them. Once real policy
// pages exist they can go back in.
const LoginFooter = () => {
  const currentYear = new Date()?.getFullYear();

  return (
    <div className="mt-8 space-y-4">
      <div className="flex items-center justify-center gap-2 p-3 bg-green-50 border border-green-200 rounded-lg">
        <Icon name="Shield" size={16} className="text-green-600" />
        <span className="text-sm font-medium text-green-800">
          FERPA-aware · Student data stays in your district's database
        </span>
      </div>

      <div className="grid grid-cols-2 gap-4 text-center">
        <div className="flex flex-col items-center gap-1">
          <Icon name="Lock" size={20} className="text-muted-foreground" />
          <span className="text-xs text-muted-foreground">
            Encrypted in transit
          </span>
        </div>
        <div className="flex flex-col items-center gap-1">
          <Icon name="Database" size={20} className="text-muted-foreground" />
          <span className="text-xs text-muted-foreground">
            You own your data
          </span>
        </div>
      </div>

      <div className="text-center text-xs text-muted-foreground">
        <p>© {currentYear} EduTracker Pro</p>
      </div>
    </div>
  );
};

export default LoginFooter;